var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 2.66669H35.5312V34.7396H3.59375V2.66669Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1927 3.67188C10.5937 3.67188 3.59375 10.6406 3.59375 19.1979C3.59375 27.7552 10.5937 34.724 19.1927 34.724C27.7917 34.724 34.7917 27.7552 34.7917 19.1979C34.7917 15.5 33.5312 12.1927 31.3958 9.47917L29.9271 11.2135C31.7917 13.4948 32.5208 16.026 32.5208 19.1979C32.5208 26.5312 26.5625 32.4583 19.1927 32.4583C11.8229 32.4583 5.86458 26.5312 5.86458 19.1979C5.86458 11.8646 11.8229 5.93229 19.1927 5.93229C21.526 5.93229 23.276 6.27083 25.1823 7.31771L26.5781 5.49479C24.3437 4.26563 21.9167 3.67188 19.1927 3.67188Z",
    fill: "#37BC09"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_50_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 27,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 1.83856H35.5312V29.3334H9.33331V1.83856Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_50_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 17.1563C14.0469 17.1563 14.526 17.6719 14.849 18.6979C15.4948 20.625 15.9531 21.5885 16.2292 21.5885C16.4375 21.5885 16.6562 21.4271 16.8802 21.1042C21.4115 13.8802 25.6042 8.03646 29.4583 3.57813C30.4583 2.42188 32.0469 1.84375 34.224 1.84375C34.7396 1.84375 35.0885 1.89063 35.2656 1.98958C35.4427 2.08333 35.5312 2.20313 35.5312 2.34896C35.5312 2.57292 35.2656 3.01563 34.7344 3.67188C28.5052 11.1198 22.7344 18.9896 17.4115 27.2708C17.0417 27.849 16.2812 28.1354 15.1354 28.1354C13.9792 28.1354 13.2917 28.0885 13.0833 27.9948C12.5312 27.75 11.8906 26.526 11.1458 24.3073C10.3073 21.8542 9.89062 20.3125 9.89062 19.6875C9.89062 19.0104 10.4531 18.3594 11.5833 17.7344C12.276 17.349 12.8906 17.1563 13.4219 17.1563Z",
    fill: "#37BC09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/iconChecked.8559bf1d.svg";
export { ForwardRef as ReactComponent };